import { render, staticRenderFns } from "./delete-talkdate-modal.vue?vue&type=template&id=1766783b"
import script from "./delete-talkdate-modal.vue?vue&type=script&lang=js"
export * from "./delete-talkdate-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports